"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import HtmlEmbed from "./webflow_modules/Embed/components/HtmlEmbed";
import Link from "./webflow_modules/Basic/components/Link";
import { CommunityListResult } from "./CommunityListResult";

export function CommunityListPopover({
  children = "",
  modalHeadingText = "Login Links",
  toggleModalRuntimeProps = {},
}) {
  return (
    <Block className={"community-list-popover"} tag={"div"}>
      <Link
        block={"inline"}
        button={false}
        className={"community-list-select"}
        options={{
          href: "#",
        }}
        {...toggleModalRuntimeProps}
      >
        <Block className={"community-list-text-heading"} tag={"div"}>
          {"Select Your Community"}
        </Block>
        <HtmlEmbed
          className={"html-embed-7"}
          content={
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">\n  <path fill="currentColor" d="M256 406.6l11.3-11.3 192-192L470.6 192 448 169.4l-11.3 11.3L256 361.4 75.3 180.7 64 169.4 41.4 192l11.3 11.3 192 192L256 406.6z"/></svg>'
          }
        />
      </Link>
      <Block
        className={"hide-opac-0---community-list-popover-modal-copy"}
        tag={"div"}
      >
        <Block className={"div-block-109"} tag={"div"}>
          <Block className={"div-block-110"} tag={"div"}>
            <Block className={"div-block-111"} tag={"div"}>
              <Block
                className={"community-list-modal-heading-line-2"}
                tag={"div"}
              >
                {modalHeadingText}
              </Block>
            </Block>
            <Link
              block={"inline"}
              button={false}
              className={"link-block-6"}
              options={{
                href: "#",
              }}
              {...toggleModalRuntimeProps}
            >
              <Block className={"text-block-16"} tag={"div"}>
                {"Close"}
              </Block>
            </Link>
          </Block>
          <Block className={"community-list-popover-slot"} tag={"div"}>
            {children ?? (
              <>
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
                <CommunityListResult text={"apartment name"} />
              </>
            )}
          </Block>
        </Block>
        <Block className={"apartment-list-background"} tag={"div"} />
      </Block>
    </Block>
  );
}
